<template>
<div v-if="visible">
    <div class="dim">
        <div class="tutorlayer">
            <a type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" @click="close()" style="cursor: pointer;">
                    <img src="../assets/img/modal-close.png" alt="">
                </span>
            </a>
            <div class="modal-header txt-center">
                <h2 class="w-100per bold col-point">강사 소개</h2>
            </div>
            <div class="modal-body pb-30">
                <div class="man-bg">
                    <div class="frame"><img src="../assets/img/frame.png" alt=""></div>
                    <img :src="'http://itm.carrotenglish.net/'+tutor_photo_pop" alt="">
                </div>
                <table class="w-100per txt-left mt-10">
                    <tr>
                        <th class="bold">Name</th>
                        <td>{{tutor_ename_pop}}</td>
                    </tr>
                    <tr>
                        <th class="bold">E-mail</th>
                        <td>{{tutor_email_pop}}</td>
                    </tr>
                    <tr>
                        <th class="bold">Language</th>
                        <td>{{tutor_lang_pop}}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'tutorModal',
    props: {
        visible: {
            type: Boolean,
            require: true,
            default: false
        },
        tutor_email:{
            type:String
        },
        tutor_ename:{
            type:String
        },
        tutor_photo:{
            type:String
        },
        lang:{
            type:String
        }
    },

    data: () => ({
        tutor_email_pop:"",
        tutor_ename_pop:"",
        tutor_photo_pop:"",
        tutor_lang_pop:""
    }),
    watch: {
        visible: function(newVal) {
			if(newVal==true) {
				this.visible = true;
                // this.doSearch();
                this.initPop();
			} else {
				this.visible = false;
				this.info = [];
            }
            
		}
    },
    mounted() {
        // console.log(this.tutor_email+"/");
    },

    methods: {
        close() {
            this.$emit("close", false);
            // this.visible = false;
        },
        initPop(){
            this.tutor_email_pop = this.tutor_email;
            this.tutor_ename_pop = this.tutor_ename;
            this.tutor_photo_pop = this.tutor_photo;
            this.tutor_lang_pop = this.lang;

        }
    }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;700&display=swap');

$point-color: #53CAFF;
$purple: #6974FF;
$gray: #B7B7B7;
$border-color: #E9E9E9;
$back-gray: #F5F5F5;

// 결석
$absent: #FF4068;
// 출석
$attend: #53CAFF;
// 휴강
$cancel: #FFB055;
// 예정
$scheduled: #E1E1E1;
// 공결
$reasons: #2FEECD;

.dim {
    background: rgba(0, 0, 0, 0.7);
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    box-sizing: border-box;
    z-index: 51;

    .tutorlayer {
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 0px 0px 20px #0000001A;
        border-radius: 20px;
        width: 90%;
        margin: 0 auto;
        max-width: 500px;
        // margin-top: 40%;
        margin-top: 300px;
        position: relative;

        .modal-header {
            h2 {
                text-align: center;
                letter-spacing: 0px;
                color: #53CAFF;
                opacity: 1;
                font-size: 20px;
                font-weight: bold;
            }

            margin-bottom: 15px;
        }

        .modal-body {
            padding: 0 20px;

            p {
                text-align: center;
                letter-spacing: 0px;
                color: #000000;
                opacity: 1;
                font-size: 14px;
            }

            .model-box {
                label {
                    width: 100%;
                }
            }
        }

        .man-bg {
            text-align: center;
            margin: 0 auto;
            width: 100px;
            height: 133px;
            background: url('../assets/img/man-bg.png') no-repeat center;
position: relative;

                    .frame {
                    position: absolute;
                    top: 0;
                }

                img {
                    width: 100px;
                    height: 133px;
                }
            }

        }

    }

    input[type="text"],
    input[type="password"] {
        border-radius: 0;
        border-top: none;
        border-right: none;
        border-left: none;
        border-bottom: 1px solid #E9E9E9;
        font-size: 16px;
        height: 45px;
        padding: 0 10px;
    }

    .modal-footer {
        a {
            background: #53CAFF 0% 0% no-repeat padding-box;
            color: white;
        }
    }

    // .btn-modal {
    //     font-weight: bold;
    //     border-bottom-right-radius: 20px;
    //     border-bottom-left-radius: 20px;
    //     text-align: center;
    //     padding: 15px 0;
    //     width: 100%;
    //     display: inline-block;
    // }

    // .btn-point {
    //     background: $point-color;
    //     color: #ffffff;
    // }

    // .btn-point-line {
    //     background: #ffffff;
    //     color: $point-color;
    //     border: 1px solid $point-color;
    // }
</style>
